/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { countryCodes } from '@/constants/locale';
import { type ISO3166Country, type Locale } from '@/types/i18n';
import { getCountryFromISO3166 } from '@/utils/getCountryFromLocale';

export function getYextCountryCodes(locale: Locale): ISO3166Country[] {
  const countries = [getCountryFromISO3166(locale)];

  if (locale === countryCodes.us) {
    countries.push(countryCodes.vi, countryCodes.pr);
  }

  return countries;
}
